import { environment } from '../../environments/environment';

function basePath(value: string | undefined): string {
    return '/' + `${environment.basePath}/${value}`.split('/').filter(Boolean).join('/');
}

export default basePath;
